import {v4 as uuidv4} from 'uuid';

import type {ItemSeriesDto} from '../../common/shared/api/gateway/ItemSeriesDto.interface';
import type {ContentRecommendVo} from '../../common/shared/api/nicolas/vo/ContentRecommendVo.interface';
import {
  type ContentRecommendGroup,
  GroupType,
  type Maybe,
  MetaInfoType,
  type User,
} from '../generated/types';
import {createPosterViewItem} from './PosterViewItem';

export function createContentRecommendGroup(
  userInfo: Maybe<User>,
  param: {
    contentRecommendVo: ContentRecommendVo;
  }
): ContentRecommendGroup {
  if ('contentRecommendVo' in param) {
    return withContentHomeItemSeriesVo(param.contentRecommendVo, userInfo);
  } else {
    throw new Error('지원하지 않는 타입입니다');
  }
}

function withContentHomeItemSeriesVo(
  {
    title,
    series_list,
    imp_label,
    description,
    is_category_visible,
    is_view_count_visible,
  }: ContentRecommendVo,
  userInfo: Maybe<User>
): ContentRecommendGroup {
  const id = uuidv4();
  return {
    id,
    title,
    type: GroupType.ContentRecommend,
    impLabel: imp_label,
    description,
    items: series_list
      ? series_list.map((item: ItemSeriesDto) => ({
          ...createPosterViewItem(userInfo, {
            itemSeriesDto: item,
            metaInfoType:
              is_category_visible && is_view_count_visible
                ? MetaInfoType.CategoryAndViewCount
                : is_category_visible && !is_view_count_visible
                  ? MetaInfoType.Category
                  : MetaInfoType.SubCategoryAndViewCount,
          }),
        }))
      : [],
  };
}
